module.exports = __webpack_public_path__ + "img/cam_6.65fd0191.png";